(function () {
  function isAccountPath(pathname) {
    return /\/account\b/.test(pathname || "");
  }

  function isAddressesPath(pathname) {
    return (pathname || "").indexOf("/account/addresses") !== -1;
  }

  function has(pattern, search) {
    return pattern.test(search || "");
  }

  function syncAccountNavActive(search) {
    var detailsLink = document.querySelector('.account-nav__link[href*="view=details"]');
    var settingsLink = document.querySelector('.account-nav__link[href*="view=settings"]');
    var couponsLink = document.querySelector('.account-nav__link[href*="view=coupons"]');
    if (!detailsLink && !settingsLink && !couponsLink) return false;

    var isSettings = has(/view=settings|view%3Dsettings|view=newsletter|view%3Dnewsletter|view=cookie_settings|view%3Dcookie_settings|view=info|view%3Dinfo|view=stay_connected|view%3Dstay_connected/i, search);
    var isCoupons = has(/view=coupons|view%3Dcoupons/i, search);
    var isDetails = has(/view=details|view%3Ddetails/i, search);

    // Only override nav active state on explicit /account?view=* screens.
    // For /account/orders/*, /account/addresses, etc., keep server-rendered active tab (e.g. VIEW ORDERS).
    if (!isSettings && !isDetails && !isCoupons) return false;

    if (detailsLink) detailsLink.classList.toggle("account-nav__link--active", isDetails);
    if (settingsLink) settingsLink.classList.toggle("account-nav__link--active", isSettings);
    if (couponsLink) couponsLink.classList.toggle("account-nav__link--active", isCoupons);
    return true;
  }

  function syncAccountBodyState() {
    try {
      var pathname = window.location.pathname || "";
      var search = window.location.search || "";
      var body = document.body;
      if (!body || !isAccountPath(pathname)) return;

      if (has(/view=coupons|view%3Dcoupons/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-account-details");
        body.classList.add("account-mobile-leaf-page");
        body.setAttribute("data-account-view", "coupons");
        body.setAttribute("data-account-subview", "coupons");
      } else if (has(/view=stay_connected|view%3Dstay_connected/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-account-details");
        body.classList.add("account-mobile-leaf-page");
        body.setAttribute("data-account-view", "stay_connected");
        body.setAttribute("data-account-subview", "stay_connected");
      } else if (has(/view=info|view%3Dinfo/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-account-details");
        body.classList.add("account-mobile-leaf-page");
        body.setAttribute("data-account-view", "info");
        body.setAttribute("data-account-subview", "info");
      } else if (has(/view=newsletter|view%3Dnewsletter/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-account-details");
        body.classList.add("account-mobile-leaf-page");
        body.setAttribute("data-account-view", "settings");
        body.setAttribute("data-account-subview", "newsletter");
      } else if (has(/view=cookie_settings|view%3Dcookie_settings/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-account-details");
        body.classList.add("account-mobile-leaf-page");
        body.setAttribute("data-account-view", "settings");
        body.setAttribute("data-account-subview", "cookie_settings");
      } else if (has(/view=settings|view%3Dsettings/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-account-details");
        body.classList.add("account-mobile-leaf-page");
        body.setAttribute("data-account-view", "settings");
        body.removeAttribute("data-account-subview");
      } else if (has(/view=details|view%3Ddetails/i, search)) {
        body.classList.remove("account-mobile-account-menu");
        body.classList.remove("account-mobile-leaf-page");
        body.classList.add("account-mobile-account-details");
        body.removeAttribute("data-account-view");
        body.removeAttribute("data-account-subview");
      } else {
        body.removeAttribute("data-account-view");
        body.removeAttribute("data-account-subview");
      }

      if (!body.hasAttribute("data-account-complete-profile-disabled") && has(/complete_profile=1|complete_profile%3D1/i, search)) {
        body.classList.add("account-complete-profile");
      }

      // Nav may mount after initial parse (theme sections/apps); retry briefly.
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        var done = syncAccountNavActive(search);
        if (done || tries >= 20) clearInterval(timer);
      }, 100);
    } catch (e) {}
  }

  function syncAddressesBodyState() {
    try {
      var pathname = window.location.pathname || "";
      var search = window.location.search || "";
      var body = document.body;
      if (!body || !isAddressesPath(pathname)) return;
      if (has(/view=add|view%3Dadd/i, search)) body.classList.add("addresses-view-add");
      if (has(/view=edit|view%3Dedit/i, search)) body.classList.add("addresses-view-edit");
    } catch (e) {}
  }

  function bindNewsletterToggles() {
    var toggles = document.querySelectorAll(".account-newsletter-settings__toggle");
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      if (toggle.dataset.bound === "1") return;
      toggle.dataset.bound = "1";

      toggle.addEventListener("click", function () {
        var isOn = toggle.classList.toggle("is-on");
        toggle.setAttribute("aria-checked", isOn ? "true" : "false");
      });
    });
  }

  function bindCouponCopyButtons() {
    var copiedLabelSource = document.querySelector("[data-copied-label]");
    var copiedLabel = copiedLabelSource ? copiedLabelSource.getAttribute("data-copied-label") : "COPIED";
    var buttons = document.querySelectorAll("[data-copy-code]");
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.boundCopy === "1") return;
      button.dataset.boundCopy = "1";

      button.addEventListener("click", function () {
        var code = button.getAttribute("data-copy-code") || "";
        if (!code || !navigator.clipboard || !navigator.clipboard.writeText) return;

        var previousText = button.textContent;
        navigator.clipboard.writeText(code).then(function () {
          button.textContent = copiedLabel;
          window.setTimeout(function () {
            button.textContent = previousText;
          }, 1600);
        }).catch(function () {});
      });
    });
  }

  function run() {
    syncAccountBodyState();
    syncAddressesBodyState();
    bindNewsletterToggles();
    bindCouponCopyButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  // Browser back/forward cache and Shopify fast navigations
  window.addEventListener("pageshow", run);
})();
